import {
  EnumForeignDocumentType,
  EnumNationality,
  EnumOffice,
  EnumUFs,
  EnumWorkerType,
  EnumWorkplace,
  EnumWorkShift,
} from '../types/enumsForms';

export const foreignDocumentTypeOptions = [
  {
    value: EnumForeignDocumentType.RNE,
    label: 'Registro Nacional de Estrangeiros (RNE)',
  },
  { value: EnumForeignDocumentType.PASSPORT, label: 'Passaporte' },
];

export const workerTypeOptions = [
  { value: EnumWorkerType.PAR, label: 'stoppage' },
  { value: EnumWorkerType.ROT, label: 'routine' },
];

export const booleanOptions = [
  { value: 'Yes', label: 'Sim' },
  { value: 'No', label: 'Não' },
];

export const nationalityOptions = [
  { value: EnumNationality.BR, label: 'Brasileiro(a) / Naturalizado(a)' },
  { value: EnumNationality.GRINGO, label: 'Estrangeiro(a)' },
];

export const workplaceOptions = [
  {
    value: EnumWorkplace.REFINARIA_SP,
    label: 'SAP Fieldlgass / escritório em são paulo / refinaria',
  },
];

export const officeOptions = [
  {
    value: EnumOffice.BA01,
    label: 'BA01 - Refinaria de Mataripe',
  },
];

export const ufOptions = [
  { value: 'AC', label: EnumUFs.AC },
  { value: 'AL', label: EnumUFs.AL },
  { value: 'AP', label: EnumUFs.AP },
  { value: 'AM', label: EnumUFs.AM },
  { value: 'BA', label: EnumUFs.BA },
  { value: 'CE', label: EnumUFs.CE },
  { value: 'DF', label: EnumUFs.DF },
  { value: 'ES', label: EnumUFs.ES },
  { value: 'GO', label: EnumUFs.GO },
  { value: 'MA', label: EnumUFs.MA },
  { value: 'MT', label: EnumUFs.MT },
  { value: 'MS', label: EnumUFs.MS },
  { value: 'MG', label: EnumUFs.MG },
  { value: 'PA', label: EnumUFs.PA },
  { value: 'PB', label: EnumUFs.PB },
  { value: 'PR', label: EnumUFs.PR },
  { value: 'PE', label: EnumUFs.PE },
  { value: 'PI', label: EnumUFs.PI },
  { value: 'RJ', label: EnumUFs.RJ },
  { value: 'RN', label: EnumUFs.RN },
  { value: 'RS', label: EnumUFs.RS },
  { value: 'RO', label: EnumUFs.RO },
  { value: 'RR', label: EnumUFs.RR },
  { value: 'SC', label: EnumUFs.SC },
  { value: 'SP', label: EnumUFs.SP },
  { value: 'SE', label: EnumUFs.SE },
  { value: 'TO', label: EnumUFs.TO },
];

export const workShiftOptions = [
  { value: 'ADM', label: EnumWorkShift.ADM },
  { value: 'TURNO', label: EnumWorkShift.TURNO },
];

export const departmentOptions = [
  {
    value: EnumOffice.BA01,
    label: 'BA01 - Refinaria de Mataripe',
  },
];